async function CalcVelocity(cfm, diameter) {
    //Referenced as "Velocity Transfer (fpm)"
    if (
        cfm > 0 &&
        diameter > 0
    ) {

        let response;

        response = await fetch("https://api.cssi.co/Calc/CalculateVelocity", {
            method: "POST",
            body: JSON.stringify(
                {
                    "cfm": cfm,
                    "diameter": diameter
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CalcVelocity;